module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.4dff84c2.ttf";